let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dGDjs")).then(() => parcelRequire('gun65'));